import { render, staticRenderFns } from "./VuesticDataTable.vue?vue&type=template&id=5e866928"
import script from "./VuesticDataTable.vue?vue&type=script&lang=js"
export * from "./VuesticDataTable.vue?vue&type=script&lang=js"
import style0 from "./VuesticDataTable.vue?vue&type=style&index=0&id=5e866928&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e866928')) {
      api.createRecord('5e866928', component.options)
    } else {
      api.reload('5e866928', component.options)
    }
    module.hot.accept("./VuesticDataTable.vue?vue&type=template&id=5e866928", function () {
      api.rerender('5e866928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-datatable/VuesticDataTable.vue"
export default component.exports